import { Dispatch } from "redux";
import { RootState } from "../../store/types.tsx";
import { ask } from "./ask";

export const askThunk =
  (searchText: string, stopAnimation: () => void) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    await ask({ dispatch, getState, searchText, stopAnimation });
  };
